module.exports = __webpack_public_path__ + "img/production.dd28659e.png";